/* global bocAmchart */
/* global AmCharts */
bocAmchart.vars = bocAmchart.vars || {};


/**
 * Applies print changes
 *
 * @param {boolean} printing - Whether the charts are being printed or not
 * @return {void}
 */
bocAmchart.modifyForPrint = function (printing) {

    // Do not apply the settings if they were already applied
    if (bocAmchart.vars.hasOwnProperty("printState") && bocAmchart.vars.printState === printing) {
        return;
    }

    // If we are printing via the exporter print option, then this JS can't run or the page will break.
    if (document.querySelector('.top-bar-wrap') !== null && document.querySelector('.top-bar-wrap').style.display === 'none') {
        return;
    }
    //If  printing is true, visiblilty on elements should be false, and vice versa
    var visible = !printing;
    bocAmchart.vars.printState = printing;

    // Iterate through the charts and set properties
    for (var i = 0; i < AmCharts.charts.length; i++) {
        var chart = AmCharts.charts[i];

        bocAmchart.initChartVars(chart);
        var chartVars = bocAmchart.vars[chart.bocSettings.id];

        if (chartVars['startDate'] && chartVars['endDate']) {
            bocAmchart.zoomBetweenDates(chart, chartVars['startDate'], chartVars['endDate']);
        } else if (chartVars['startIndex'] && chartVars['endIndex']) {
            bocAmchart.zoomBetweenIndexes(chart, chartVars['startIndex'], chartVars['endIndex']);
        }

        //set the default print height and width
        var printHeight = 350;

        //Class name for print margins
        var printMarginClass = 'amchart-print-margin';

        //If the print height is defined in the shortcode, update the print height
        var args = chart.bocSettings.args;
        if (args !== undefined && args.hasOwnProperty("printheight")) {
            printHeight = args.printheight;
        }

        // Resizes all the charts on the page to the specified width and height
        var previousHeight = chart.previousHeight;
        var chartClasses = chart.div.classList;
        var chartStyle = chart.div.style;

        if (previousHeight !== 0) {
            if (printing) {
                chartClasses.add(printMarginClass);
                chartStyle.maxWidth = "13cm";
                chartStyle.minWidth = "13cm";
                chartStyle.height = printHeight + 'px';
                chartStyle.minHeight = chartStyle.height;
                bocAmchart.vars.initialHeights[i] = previousHeight;
            } else {
                chartClasses.remove(printMarginClass);
                chartStyle.maxWidth = "";
                chartStyle.minWidth = "";
                chartStyle.height = bocAmchart.vars.initialHeights[i] + 'px';
                chartStyle.minHeight = chartStyle.height;
            }
        }

        // If the chart has an external legend, resize that too
        if (chart.hasOwnProperty('legend') && chart.legend !== null && chart.legend.hasOwnProperty('divId')) {
            var legend = jQuery("#" + chart.legend.divId)[0];

            if (legend) {
                if (printing) {
                    legend.classList.add(printMarginClass);
                    legend.style.width = "13cm";
                } else {
                    legend.classList.remove(printMarginClass);
                    legend.style.width = "";
                }
            }
        }

        //Hide horizontal scrollbar
        if (chart.hasOwnProperty('chartScrollbar')) {
            chart.chartScrollbar.enabled = visible;
        }

        //Hide vertical scrollbar
        if (chart.hasOwnProperty('valueScrollbar')) {
            chart.valueScrollbar.enabled = visible;
        }

        if (!chart.div.classList.contains('no-legend') && chart.type !== 'pie') {
            // Iterate through each graph and hide inactive graphs in legend
            for (var j = 0; j < chart.graphs.length; j++) {
                var graph = chart.graphs[j];
                if (graph.hidden === true) {
                    graph.visibleInLegend = visible;
                }
            }
        }

        //validate charts so changes take effect
        chart.validateNow(true, false);
    }
};


/**
 * Sets up triggers for the print changes
 *
 * @return {void}
 */
jQuery(document).ready(bocAmchart.modifyForPrintSetup = function () {
    bocAmchart.vars.initialHeights = {};

    // onbeforeprint happens before media query
    // so this will be cancelled in target function unless the onbeforeprint is not working
    if (window.matchMedia) {
        var mediaQueryList = window.matchMedia("print");
        mediaQueryList.addListener(function (media) {
            if (media.matches) {
                bocAmchart.modifyForPrint(true);
            } else {
                bocAmchart.modifyForPrint(false);
            }
        });
    }

    var _onbeforeprint = window.onbeforeprint;
    var _onafterprint = window.onafterprint;

    jQuery(window).bind("beforeprint", function () {
        _onbeforeprint && _onbeforeprint();
        bocAmchart.modifyForPrint(true);
    });

    jQuery(window).bind("afterprint", function () {
        _onafterprint && _onafterprint();
        bocAmchart.modifyForPrint(false);
    });

});
